import React, { useEffect, useState } from 'react';
import AdminLayout from './AdminLayout';
import Loader from '../../components/Loader';
import api from '../../api';

export default function AdminDashboard() {
  const [data, setData] = useState(null);

  useEffect(function() {
    api.get('/stats/dashboard').then(function(res) { setData(res.data); }).catch(function() {});
  }, []);

  if (!data) return <AdminLayout><Loader /></AdminLayout>;
var todays     = data.dailyStats[0];
  var totalViews = data.dailyStats.reduce(function(sum, s) { return sum + (s.pageViews || 0); }, 0);
  var topDest   = Object.entries(data.popularDestinations || {}).sort(function(a, b) { return b[1] - a[1]; }).slice(0, 5);

var stats = [
    { label: 'Total Inquiries',  value: data.totalInquiries, icon: '📋' },
    { label: 'New (Unhandled)',  value: data.newInquiries,   icon: '🔔' },
    { label: 'Page Views (30d)', value: totalViews,          icon: '👁️' },
    { label: 'Total Today',      value: todays?.pageViews || 0, icon: '📅' }
  ];

  return (
    <AdminLayout>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24, flexWrap: 'wrap', gap: 12 }}>
        <h1 style={{ margin: 0 }}>Dashboard</h1>
        <button
          className="btn btn-outline"
          style={{ borderColor: '#ef4444', color: '#ef4444', fontSize: '0.85rem', padding: '8px 16px' }}
          onClick={async function() {
            if (!window.confirm('Reset ALL statistics? Page views, visitor counts and destination views will be cleared. Inquiry counts will remain since they come from the Inquiries collection.')) return;
            try {
              await api.delete('/stats/reset');
              window.location.reload();
            } catch (err) {
              alert('Reset failed: ' + (err.response?.data?.message || err.message));
            }
          }}
        >
          🗑 Reset Stats
        </button>
      </div>

      {/* Stat cards */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
        gap: 16, marginBottom: 28
      }}>
        {stats.map(function(s) {
          return (
            <div key={s.label} className="card" style={{ padding: 20 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
                <span style={{ fontSize: '1.3rem' }}>{s.icon}</span>
                <p style={{ margin: 0, fontSize: '0.78rem', opacity: 0.6, fontWeight: 600 }}>{s.label}</p>
              </div>
              <p style={{ margin: 0, fontSize: '2rem', fontWeight: 700, fontFamily: 'var(--font-display)', color: 'var(--bj-clay)' }}>
                {s.value}
              </p>
            </div>
          );
        })}
      </div>

      {/* Lower section */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: 20
      }}>
        <div className="card" style={{ padding: 20 }}>
          <h3 style={{ marginBottom: 16, fontSize: '1rem' }}>Inquiries by Type</h3>
          {data.inquiriesByType.length === 0 && <p style={{ opacity: 0.6 }}>No inquiries yet.</p>}
          {data.inquiriesByType.map(function(t) {
            return (
              <div key={t._id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '9px 0', borderBottom: '1px solid var(--bj-sand)' }}>
                <span style={{ textTransform: 'capitalize', fontSize: '0.9rem' }}>{t._id}</span>
                <strong style={{ color: 'var(--bj-clay)' }}>{t.count}</strong>
              </div>
            );
          })}
        </div>

        <div className="card" style={{ padding: 20 }}>
          <h3 style={{ marginBottom: 16, fontSize: '1rem' }}>Popular Destinations (30d)</h3>
          {topDest.length === 0
            ? <p style={{ opacity: 0.6 }}>No destination views logged yet.</p>
            : topDest.map(function(d) {
              return (
                <div key={d[0]} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '9px 0', borderBottom: '1px solid var(--bj-sand)' }}>
                  <span style={{ textTransform: 'capitalize', fontSize: '0.9rem' }}>{d[0].replace(/-/g, ' ')}</span>
                  <strong style={{ color: 'var(--bj-clay)' }}>{d[1]}</strong>
                </div>
              );
            })
          }
        </div>
      </div>
    </AdminLayout>
  );
}